export const ru = {
    'select-ad-platforms': 'Выбор рекламных поверхностей',
    'select-ad-platforms-diff-group':
        'Выберите рекламные поверхности. Учитывайте их формат — добавляйте поверхности, для которых у вас есть креативы подходящего размера. Вы можете выбрать поверхности в нескольких городах одновременно.',
    'select-all': 'выбрать все'
};
